export const getPaginationInitialState = (
  additionalData?: object
): {
  skip: number
  take: number
} => {
  const sessionPageSize = sessionStorage.getItem('itemsPerPage')
  return {
    ...additionalData,
    skip: 0,
    take: sessionPageSize ? parseInt(sessionPageSize) : 10,
  }
}
